export default __webpack_public_path__ + "static/media/hero-image.e42c5802.png";